function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 1H37L34 16H3L6 1Z",
  fill: "#E84855"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2282 14L10.7722 11.136C11.1242 9.264 11.3642 7.488 11.5082 6.4H11.5402C11.6522 7.744 11.7482 8.48 12.0842 9.984L12.9482 14H14.6602L16.7242 3.216H14.9962L14.4682 6.016C14.1322 7.808 13.9402 9.664 13.7962 10.848H13.7642C13.6842 9.952 13.5082 8.928 13.2362 7.504L12.4042 3.216H10.5802L8.51619 14H10.2282ZM22.3951 7.536H19.9791L20.5071 4.976H22.9871L23.3391 3.216H18.8271L16.7631 14H21.4671L21.8191 12.224H19.0991L19.6911 9.232H22.0591L22.3951 7.536ZM25.1026 3.216L23.8386 9.888C23.7266 10.544 23.6466 11.12 23.6466 11.584C23.6466 13.168 24.4466 14.128 26.2066 14.128C28.3666 14.128 29.3746 12.624 29.8706 10.016L31.1666 3.216H29.1666L27.8066 10.304C27.5026 11.904 27.0706 12.352 26.4306 12.352C25.9346 12.352 25.6306 12.032 25.6306 11.408C25.6306 11.088 25.6786 10.704 25.7746 10.224L27.1186 3.216H25.1026Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 40,
  height: 21,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgNeu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 21,
    viewBox: "0 0 40 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeu);
export default __webpack_public_path__ + "static/media/neu.e1940063.svg";
export { ForwardRef as ReactComponent };